import { render, staticRenderFns } from "./FacturaList.vue?vue&type=template&id=fdb7fc0e"
import script from "./FacturaList.vue?vue&type=script&lang=js"
export * from "./FacturaList.vue?vue&type=script&lang=js"
import style0 from "./FacturaList.vue?vue&type=style&index=0&id=fdb7fc0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports